import { render } from "./About.vue?vue&type=template&id=14267238&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=14267238&lang=scss&scoped=true"
import "./About.vue?vue&type=style&index=1&id=14267238&lang=css"

import exportComponent from "/home/callum/Documents/CODE/raphaelschoen/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14267238"]])

export default __exports__